// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"An-z","breadcrumbForward":"Bn-z","breadcrumbBack":"Cn-z","selected":"Dn-z"};